<template>
  <div>
    <h3>Has it been easy for you to follow the recommended changes?</h3>
    <v-form-group class="card-selector" :validator="$v.easyToFollowChangesStatus">
      <b-form-radio v-model="survey.easyToFollowChangesStatus" name="easyToFollow" :value=easyToFollowChangesType.Yes>Yes</b-form-radio>
      <b-form-radio v-model="survey.easyToFollowChangesStatus" name="easyToFollow" :value=easyToFollowChangesType.No>No</b-form-radio>
      <b-form-radio v-model="survey.easyToFollowChangesStatus" name="easyToFollow" :value=easyToFollowChangesType.NotApplicable>Not Applicable</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import easyToFollowChangesType from "enums/easy-to-follow-changes-type";

  export default {
    mixins: [formMixin],
    data() {
      return {
        easyToFollowChangesType: easyToFollowChangesType,
      };
    },

    validations: {
      easyToFollowChangesStatus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      easyToFollowChangesStatus() { return this.survey.easyToFollowChangesStatus }
    },

    methods: {
      onSubmit() {

      }
    }
  };
</script>